import { ContractLegalTextPdfResponse } from 'api/contractAuthAPI'
import { CallAPIAction, Status } from 'api/types'
import { handleLegalTextData } from 'common/utils/HandleLegalTextData'
import Actions from 'redux/actions'

type State = {
  response: ReturnType<typeof handleLegalTextData> | null
} & Status

const initialState: State = {
  isLoading: false,
  success: false,
  fail: false,
  response: null,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_CONTRACT_LEGAL_TEXT_ASYNC,
    Actions.GET_CONTRACT_LEGAL_TEXT_SUCCESS,
    Actions.GET_CONTRACT_LEGAL_TEXT_FAIL,
    ContractLegalTextPdfResponse
  >,
) => {
  switch (action.type) {
    case Actions.GET_CONTRACT_LEGAL_TEXT_SUCCESS:
      return {
        ...state,
        ...action.status,
        response: handleLegalTextData(action.payload),
      }
    case Actions.GET_CONTRACT_LEGAL_TEXT_ASYNC:
    case Actions.GET_CONTRACT_LEGAL_TEXT_FAIL:
      return {
        ...state,
        ...action.status,
      }
    default:
      return state
  }
}
